module.exports = __webpack_public_path__ + "img/44ne.ec006c3d.svg";